export const MASTER_DATA_KEY = 'masterData'